import Vue from 'vue'
import Vuex from 'vuex'
import './http'
import axios from 'axios'
import router from '../router'
import jwtDecode from 'jwt-decode'
import get from 'lodash/get'
import moment from 'moment-timezone'

import alertConditionTypesModule from './modules/alertConditionTypes'
import alertDampeningModule from './modules/alertDampening'
import alertNotificationsModule from './modules/alertNotifications'
import alertsModule from './modules/alerts'
import carriersModule from './modules/carriers'
import companiesModule from './modules/companies'
import filminfoModule from './modules/filminfo'
import loadrecipeModule from './modules/loadrecipe'
import machinesModule from './modules/machines'
import reportsModule from './modules/reports'
import reportTemplatesModule from './modules/reportTemplates'
import roleTypesModule from './modules/roleTypes'
import timePeriodsModule from './modules/timePeriods'
import unitsModule from './modules/units'
import usersModule from './modules/users'
import userStateModule from './modules/userState'

Vue.use(Vuex)

// Polling to check JWT timeout
setInterval(() => {
  if (store.state.jwtExpiration && store.state.jwtExpiration - moment().unix() < 0) {
    window.localStorage.setItem('token', '')
    store.commit('setUser', null)
    store.commit('setJwtExpiration', null)
    console.log('auto logout')
  }
}, 10000)

let errorTimeout

const store = new Vuex.Store({
  state: {
    loading: true,
    user: null,
    showNav: false,
    showUserNav: false,
    jwtExpiration: null,
    globalError: null
  },
  mutations: {
    setLoading (state, loading) {
      state.loading = loading
    },
    setUser (state, user) {
      state.user = user
    },
    setJwtExpiration (state, value) {
      state.jwtExpiration = value
    },
    setShowNav (state, value) {
      state.showNav = value
    },
    setShowUserNav (state, value) {
      state.showUserNav = value
    },
    setGlobalError (state, value) {
      state.globalError = value
      clearTimeout(errorTimeout)
      if (value) {
        errorTimeout = setTimeout(() => {
          state.globalError = null
        }, 10000)
      }
    }
  },
  getters: {
    readOnly: (state) => {
      return state.user && ['ROLE_READONLY', 'ROLE_SELECTION'].includes(state.user.roles) // If the user has a read-only role
    },
    userRole: (state) => {
      return (state.user && state.user.roles) || null
    },
    skinProp: (state) => (key) => {
      let skin = {
        key: 'hilife',
        name: 'HiLIFE',
        secondaryName: 'HiLIFE',
        colors: {
          primary: '#20a8d8',
          secondary: '#2ca58d'
        },
        sidebarStyle: {},
        logo: 'img/logo.jpg',
        loginContainerStyle: {
          backgroundImage: 'url("img/hli-building-darkened.png")',
          backgroundPositionY: 'top'
        },
        footerLogo: null
      }
      if (window.localStorage.getItem('skin') === 'sigma') {
        skin = {
          key: 'sigma',
          name: 'Sigma',
          secondaryName: 'Sigma Pack-Rite',
          colors: {
            primary: '#27327a',
            secondary: '#27327a',
            accent: '#d64937'
          },
          sidebarStyle: {
            // backgroundColor: '#27327a',
            // background: '#27327a',
            border: '#d64937 2px solid'
          },
          logo: 'img/sigma/logo.jpg',
          loginContainerStyle: {
            backgroundImage: 'url("img/sigma/landing-bg-darkened.png")',
            backgroundPositionY: 'top'
          },
          footerLogo: 'img/sigma/footer-logo.jpg'
        }
      }
      return get(skin, key)
    }
  },
  actions: {
    async rootBootstrap ({ state, dispatch, commit, getters }, payload = {}) {
      console.log('root bootstrap', router.currentRoute.query)
      // Always refresh if refresh token is provided

      let currentToken = window.localStorage.getItem('token')
      let decodedToken
      commit('setLoading', true)
      try {
        if (currentToken) {
          decodedToken = jwtDecode(currentToken)
          if (decodedToken && decodedToken.exp) {
            // ADD FOR LOCAL DEV
            // commit('setJwtExpiration', moment().add(1, 'hour').unix())
            if (decodedToken.exp < moment().unix()) {
              currentToken = null
            }
          } else {
            console.log('invalid token', decodedToken)
            currentToken = null
          }
        }

        if (!currentToken && router.currentRoute.query._t) {
          try {
            let refreshResponse = await axios({
              method: 'POST',
              url: '/rest/token/refresh',
              data: {
                refresh_token: router.currentRoute.query._t
              }
            })
            if (refreshResponse && refreshResponse.data && refreshResponse.data.token) {
              currentToken = refreshResponse.data.token
              decodedToken = jwtDecode(currentToken)
              window.localStorage.setItem('token', refreshResponse.data.token)
            }
          } catch (e) {
            console.log('refresh response', e)
          }
        }

        if (!currentToken) {
          commit('setUser', null)
          commit('setLoading', false)
          return
        }

        if (decodedToken) {
          commit('setJwtExpiration', decodedToken.exp)
        }

        let response = await axios({
          method: 'GET',
          url: '/rest/user',
          params: {
            username: 'SELF'
          }
        })
        if (response && response.data) {
          commit('setUser', response.data)
          await dispatch('bootstrap')
        }
        commit('setLoading', false)
      } catch (e) {
        console.log('root bootstrap error', e)
        commit('setUser', null)
        commit('setLoading', false)
      }
    },
    async logout ({ state, dispatch, commit, getters }) {
      commit('setUser', null)
      commit('setJwtExpiration', null)
      window.localStorage.setItem('token', '')
      router.push({ path: '/' })
    }
  },
  modules: {
    alertConditionTypes: alertConditionTypesModule,
    alertDampening: alertDampeningModule,
    alertNotifications: alertNotificationsModule,
    alerts: alertsModule,
    carriers: carriersModule,
    companies: companiesModule,
    filminfo: filminfoModule,
    loadrecipe: loadrecipeModule,
    machines: machinesModule,
    reports: reportsModule,
    reportTemplates: reportTemplatesModule,
    roleTypes: roleTypesModule,
    timePeriods: timePeriodsModule,
    units: unitsModule,
    users: usersModule,
    userState: userStateModule
  }
})

window.$store = store

export default store
